import {HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ApiService} from '@cas-hub/acabim-common-client';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {DataExportRequest} from '../_models/data-export.model';

@Injectable({
    providedIn: 'root'
})
export class DataExportService extends ApiService {

    protected controller = 'data-export/DataExport';

    public getCurrentRequests(): Observable<DataExportRequest[]> {
        return this.client.get(this.url(''), {
            headers: this.defaultHeaders,
            responseType: 'json'
        }).pipe(map(item => item as DataExportRequest[]));
    }

    public getDownloadUrl(exportRequestId: string): Observable<string> {
        return this.client.get(this.url('url'), {
            headers: this.defaultHeaders,
            params: new HttpParams().set('executionId', exportRequestId),
            responseType: 'json'
        }).pipe(map(item => (item as any).url));
    }

    public startBuildingDataExport(bimModelId: string): Observable<DataExportRequest> {
        return this.client.get(this.url('building-data'), {
            headers: this.defaultHeaders,
            params: new HttpParams().set('modelId', bimModelId),
            responseType: 'json'
        }).pipe(map(item => item as DataExportRequest));
    }
}
